import type { GridMapboxStyle } from './styles';

export const gridsAbstract = (style: GridMapboxStyle) => [
  {
    minzoom: 12,
    layout: {
      'text-field': ['get', 'label'],
      'text-size': style.textSize,
      'text-ignore-placement': false,
      'text-allow-overlap': false,
      visibility: 'visible',
    },
    type: 'symbol',
    id: 'abstract-labels',
    paint: {
      'text-color': style.textColor,
      ...(style.textHaloColor &&
        style.textHaloWidth && {
          'text-halo-color': style.textHaloColor,
          'text-halo-width': style.textHaloWidth,
        }),
    },
    source: 'grids',
    'source-layer': 'abstract_centers',
  },
  {
    minzoom: 12,
    id: 'abstract-grid',
    type: 'line',
    layout: {
      visibility: 'visible',
    },
    paint: {
      'line-color': style.lineColor,
      'line-width': style.lineWidth,
    },
    source: 'grids',
    'source-layer': 'abstract',
  },
];
